import * as React from "react";
import { eventsDebug } from "~/common/audit/trackEvent";
import { trackAIPageView } from "~/EasyProjects/AppInsights/AppInsightsHelper";
import { trackAmplitudeEvent } from "~/sharedComponents/amplitude/trackAmplitudeEvent";

export type PageViewProps = {
    /**
     * Key of the page that won't be changed even if title is changed.
     */
    pageKey: string;
    /**
     * Title of the page.
     * Should be always in English, otherwise we won't be able to use it in analytics.
     */
    pageTitle: string;
};

export const trackPageView = ({ pageKey, pageTitle }: PageViewProps) => {
    if (eventsDebug.isEnabled()) {
        // eslint-disable-next-line no-console
        console.log(`trackPageView: '${pageTitle}' (pageKey: '${pageKey}')`);
    }

    trackAIPageView({
        name: pageKey,
        uri: window.location.pathname,
    });

    // eslint-disable-next-line no-restricted-syntax
    trackAmplitudeEvent(`Page Viewed - ${pageTitle}`, {
        // just a marked for filtering all "page viewed" events
        "page viewed": true,
        pageKey,
    });
};

export const useTrackPageView = (props: PageViewProps) => {
    React.useEffect(() => {
        trackPageView(props);
    }, []);
};
